import request from '@/utils/axios'

//获取用户的一个总信息
export function userMainInfo(form) {
    return request({
        url: '/main/user-center',
        method: 'get',
        params: form
    })
}

//获取绑定的银行卡/支付宝
export function getBindCards(form) {
    return request({
        url: '/account/get_bind_card',
        method: 'get',
        params: form
    })
}

//获取用户概览的所有信息
export function basicUserInfo(form) {
    return request({
        url: '/main/home',
        method: 'get',
        params: form
    })
}

//获取用户当前余额
export function userBalance(form) {
    return request({
        url: '/account/get_user_balance',
        method: 'get',
        params: form
    })
}

//获取今日交易状态
export function todayDataCount(form) {
    return request({
        url: '/sale_detail/get_today_count',
        method: 'get',
        params: form
    })
}

//货单记录
//获取货单记录
export function orderNoRecord(form) {
    return request({
        url: '/sale_detail/get_order_list',
        method: 'get',
        params: form
    })
}

//撤回货单
export function revokeOrder(form) {
    return request({
        url: '/sale_detail/revoke_order',
        method: 'get',
        params: form
    })
}

//交易明细
//获取交易明细
export function dealRecord(form) {
    return request({
        url: '/sale_detail/recordList',
        method: 'get',
        params: form
    })
}
//获取交易明细 通过货单号或卡号 精确查询
export function dealRecordByKeyword(form) {
    return request({
        url: '/sale_detail/record',
        method: 'get',
        params: form
    })
}
//申诉交易
export function appealing(form) {
    return request({
        url: '/ajax/complaint',
        method: 'get',
        params: form
    })
}
//获取交易明细统计
export function exchangeCount(form) {
    return request({
        url: '/sale_detail/get_record_count',
        method: 'get',
        params: form
    })
}

//降价卡折扣(通用货单和卡单)
export function changeDiscount(form) {
    return request({
        url: '/sale_detail/edit_discount',
        method: 'get',
        params: form
    })
}

//批量降价(适用于待售卡)
export function lotsCardReduce(form) {
    return request({
        url: '/speed_up/edit_discount_batch',
        method: 'get',
        params: form
    })
}

//绑卡
//验证银行
export function checkBank(form) {
    return request({
        url: '/account/searchBankBin',
        method: 'get',
        params: form
    })
}
//获取主流银行信息
export function getBankList(form) {
    return request({
        url: '/common/get_bank_list',
        method: 'get',
        params: form
    })
}
//获取验证码
export function phoneCode(form) {
    return request({
        url: '/auth/smst',
        method: 'post',
        params: form
    })
}
//绑定银行卡或者支付宝
export function bindBankOrAlipay(form) {
    return request({
        url: '/account/bind',
        method: 'post',
        params: form
    })
}

//解绑银行卡
export function unbindBank(form) {
    return request({
        url: '/account/unbind',
        method: 'get',
        params: form
    })
}

//提现
//获取提现额度和手续费
export function commissionInfo(form) {
    return request({
        url: '/common/get_commission',
        method: 'get',
        params: form
    })
}

//提现操作
export function withdrawCash(form) {
    return request({
        url: '/account/withdraw',
        method: 'post',
        params: form
    })
}
//提现记录
export function withdrawRecord(form) {
    return request({
        url: '/account/withdrawalList',
        method: 'get',
        params: form
    })
}

//批量降价
export function lotsReduceInfo(form) {
    return request({
        url: '/speed_up/select_wait_sell_group',
        method: 'get',
        params: form,
    })
}

//实名认证
//查询认证进行的程度
export function certificationProcess(form) {
    return request({
        url: '/account/isCertification',
        method: 'get',
        params: form
    })
}

//支付宝认证(二维码)
export function alipayCertification(form) {
    return request({
        url: '/ali_certification/do_auth',
        method: 'get',
        params: form
    })
}

//获取认证询问所需要的bizno
export function alipayCertQueryBizno(form) {
    return request({
        url: '/ali_certification/cer_ali_records',
        method: 'get',
        params: form
    })
}

//用户提交支付宝认证询问
export function alipayCertQuery(form) {
    return request({
        url: '/ali_certification/query',
        method: 'get',
        params: form
    })
}

//百度认证(二维码)
export function aipCertification(form) {
    return request({
        url: '/aip/do_auth',
        method: 'get',
        params: form
    })
}

//获取百度认证询问所需要的bizno
export function aipCertQueryBizno(form) {
    return request({
        url: '/aip/cer_ali_records',
        method: 'get',
        params: form
    })
}

//用户提交百度认证询问
export function aipCertQuery(form) {
    return request({
        url: '/aip/query',
        method: 'get',
        params: form
    })
}

//账单
export function getBillList(form) {
    return request({
        url: '/bill/list',
        method: 'get',
        params: form
    })
}

//账单统计
export function getBillCount(form) {
    return request({
        url: '/bill/bill_count',
        method: 'get',
        params: form
    })
}

// 根据卡id查询交易详情
export function getRecordDetail(form) {
    return request({
        url: '/sale_detail/record-detail',
        method: 'get',
        params: form
    })
}

// 提现详情
export function getWithdrawalDetail(form) {
    return request({
        url: '/account/withdrawal_detail',
        method: 'get',
        params: form
    })
}



// WEBPACK FOOTER //
// ./src/api/userinfo.js